import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logoLight from '../assets/logo-light.png';
import { paths } from '../routes/paths';
import { pagesAPI } from '../services/api';
import { useConsent } from './CookieConsent';
import '../styles/site.css';

// Navy footer from the Figma "attendee chrome". The legal links are the published pages of Admin > Pages (privacy policy, terms and
// conditions, anything the admin adds), then Cookie preferences (opens the window) and Data rights.
const SUPPORT_EMAIL = 'support@eventsignite.ie';

// No Figma screen shows an "organiser" entry point from the attendee-facing pages, so the footer
// carries one: /organiser/login and /organiser/apply would otherwise only be reachable by typing the URL.
function Footer() {
  const [pages, setPages] = useState([]);
  const { openPreferences } = useConsent();
  useEffect(() => { pagesAPI.list().then(setPages).catch(() => {}); }, []);

  return (
    <footer className="site-footer">
      <div className="site-footer-in">
        <div className="site-footer-top">
          <img src={logoLight} alt="Events Ignite" className="site-footer-logo" />
          <ul className="site-footer-links">
            {/* the class keeps the dark-mode "a:not([class])" accent colour off these links: the footer is white on navy in both themes */}
            {pages.map((p) => <li key={p.slug}><Link className="site-footer-link" to={paths.page(p.slug)}>{p.title}</Link></li>)}
            <li><button type="button" className="site-footer-btn" onClick={openPreferences}>Cookie preferences</button></li>
            <li><Link className="site-footer-link" to={paths.dataRights}>Data rights</Link></li>
            <li><Link className="site-footer-link" to={paths.organiser.login}>For organisers</Link></li>
            <li><a className="site-footer-link" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></li>
          </ul>
        </div>
        <p className="site-footer-legal">&copy; {new Date().getFullYear()} Events Ignite Ltd · Tickets are sold by the organiser</p>
      </div>
    </footer>
  );
}

export default Footer;
